import styled, { css } from 'styled-components';
import { Tooltip } from '../TooltipText/styles';

const outlinedStyles = css`
  background-color: transparent;
  color: ${(props) => props.theme[props.$cor]};
  border: 1px solid ${(props) => props.theme[props.$cor]};
`;

export const Conteiner = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  height: 35px;
  margin: 0 2px;
  padding: 10px;

  color: ${(props) =>
    !props.$outlined
      ? props.$modoEscuro
        ? props.theme.DARK
        : props.theme.LIGHT
      : props.theme[props.$cor]};
  background-color: ${(props) => (!props.$outlined ? props.theme[props.$cor] : 'transparent')};
  border: ${(props) => (!props.$outlined ? 'none' : `1px solid ${props.theme[props.$cor]}`)};
  border-radius: 15px;
  outline: none;

  font-weight: 500;
  letter-spacing: 1px;

  z-index: 4;
  cursor: pointer;

  &:not(:disabled):hover {
    background-color: ${(props) => props.theme[props.$cor + '_DARKER']};
    color: ${(props) =>
      !props.$outlined ? (props.$modoEscuro ? props.theme.DARK : props.theme.LIGHT) : 'white'};
  }

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }

  &:disabled {
    color: ${(props) =>
      !props.$outlined
        ? props.$modoEscuro
          ? props.theme.DARK
          : props.theme.LIGHT
        : props.theme[props.$cor]};
    background-color: ${(props) => (!props.$outlined ? props.theme[props.$cor] : 'transparent')};
    border: ${(props) => (!props.$outlined ? 'none' : `1px solid ${props.theme[props.$cor]}`)};
    cursor: not-allowed;
  }

  ${(props) => props.$outlined && outlinedStyles}
`;

export const TextArea = styled.span`
  margin: 0 5px;

  color: ${(props) =>
    !props.$outlined
      ? !props.$modoEscuro
        ? props.theme.LIGHT
        : props.theme.DARK
      : props.theme[props.$cor]};

  white-space: nowrap;
`;
